import '../helpers.js';
import { initMemberNavDeps } from './member-nav-deps.js';
import { initSettingsNavScroll } from '../shared/settings-nav.js';
import { registerMemberNavAction, runMemberNavAction } from './member-nav-registry.js';
import { showAlertMsg } from './member-show-alert-msg.js';
import { openMemberPayPage } from '../pledge-pay/pledge-pay-member.js';
import { pledgeKey } from '../pledge-pay/pay-pledge-map.js';
import { init as initOpenCreditAddModal } from '../manager/open-credit-add-modal';
import { openMemberOpenPaymentAddModal } from './open-member-payment-add-modal.js';
import { openSchedule, initScheduleModal } from './schedule-modal.js';
import { initMemberPaymentDependencies } from './member-payment-dependencies.js';
import { initShabbosPage } from '../shabbos-page.js';
import { openZmanim } from './zmanim-modal.js';
import { openIndexPage } from './member-open-index-page.js';
import { MemberLoginPage, resendOTP } from './member-login-flow.js';
import { setBack, wireBackToHistory } from '../shared/nav-buttons.js';
import { createRouter } from '../shared/router.js';
import { navigateWithOverlay } from '../shared/guarded-navigation.js';
import { navigateAuthRedirect } from '../shared/auth-navigate.js';
import { handleMemberSpaRequestError } from './member-spa-auth.js';
import {
    runAjaxCommand as runMemberSpaAjax,
    toggleLoginFlowBars,
    syncFullPageBodyClasses,
} from './member-spa-ajax.js';
import {
    openDonationPage,
    backToDonationPage,
    openAmountPage,
    backToAmountPage,
    openFreqDurPage,
    openRecurringPresetAmount,
    backToFreqDurPage,
    openDonorInfoPage,
    backToDonorInfoPage,
    openPaymentPage,
    openSavedPaymentPage,
    processDonorInfoSubmit,
    routeCharityDonation,
    memberLogOut,
} from './donation-flow-nav.js';
import {
    memberRoutes as routes,
    memberPages,
    memberResetHeader,
    withMemberCongregationQuery,
    MEMBER_PAGE_TITLES,
    memberNavigateTo as navigateTo,
    accountSettingsPageForTab,
    ACCOUNT_SETTINGS_PAGE_BY_TAB,
} from './member-nav-config.js';

function runAjaxCommand(route, method) {
    return runMemberSpaAjax(route, method, function () {
        if ($('#index_paging .member-pledges-page').length) {
            initMemberNavDeps();
        }
    });
}

export function resetIndexHeader() {
    $('body').removeClass('shabbos-mode-active');
    const headerCfg = memberResetHeader();
    const overlayUrl = String(headerCfg.overlayImageUrl || '').trim();
    const bgUrl = String(headerCfg.backgroundImageUrl || '').trim();
    if (bgUrl !== '') {
        $('body').css({ 'background-image': 'url(' + overlayUrl + '), url(' + bgUrl + ')' });
    } else if (overlayUrl !== '') {
        $('body').css({ 'background-image': 'url(' + overlayUrl + ')' });
    }
    if (headerCfg.hasCongregation) {
        $('#logoDivInfo').html(String(headerCfg.logoHtml || ''));
    }
}

function readShabbosPageConfig() {
    const el = document.getElementById('shabbos-page-config');
    if (!el || !el.textContent) {
        return null;
    }
    try {
        return JSON.parse(el.textContent);
    } catch (err) {
        console.error('readShabbosPageConfig: invalid shabbos-page-config JSON', err);
        return null;
    }
}

export function showShabbosPage(options) {
    runAjaxCommand(withMemberCongregationQuery(routes().shabbos)).then(function () {
        const cfg = readShabbosPageConfig();
        if (cfg) {
            initShabbosPage(cfg, options);
        }
    });
}

export function initMemberNav($) {
    'use strict';

    let checkedCheckboxesValues = [];

    function OpenSeatingPage(floor_plan_id) {
        const id = floor_plan_id;
        const hasPlan = id !== null && id !== undefined && id !== '';
        const base = routes().seatingPage;
        const request = hasPlan
            ? runAjaxCommand(base + '/' + encodeURIComponent(String(id)))
            : runAjaxCommand(base);
        request.then(function () {
            if (hasPlan) {
                navigateTo('seatingPlan', { floor_plan_id: id });
            } else {
                navigateTo('seating');
            }
        });
    }

    function openMemberPayBillPage(pledge_id) {
        if (!pledge_id) {
            const seen = new Set();
            checkedCheckboxesValues = [];
            $('input:checkbox[name="action_check[]"]:checked').each(function () {
                const val = $(this).val();
                if (val && !seen.has(val)) {
                    seen.add(val);
                    checkedCheckboxesValues.push(val);
                }
            });
            if (checkedCheckboxesValues.length === 0) {
                showAlertMsg('You must select at least 1 checkbox to run the pay selected pledges', 'danger');
                $('#mass_action').val('').prop('selected', true);
                return false;
            }
        }

        runAjaxCommand(routes().memberPayBill.replace('PLACEHOLDER', pledge_id)).then(function () {
            if (!$('#pledge_pay_body').length) {
                return;
            }
            if (pledge_id) {
                openMemberPayPage(pledgeKey('pledge', pledge_id));
            } else {
                openMemberPayPage(checkedCheckboxesValues);
            }
            navigateTo('pledgesPay');
            setBack(true);
        });
    }

    function MemberForgotPage() {
        runAjaxCommand(routes().memberForgot).then(function () {
            navigateTo('recoverPin');
        });
    }

    function MemberRegisterPage() {
        navigateWithOverlay({
            url: routes().memberRegister,
            type: 'GET',
            success(data) {
                if (data && typeof data.redirect === 'string' && data.redirect !== '') {
                    navigateAuthRedirect(data.redirect);
                    return;
                }
                $('#index_paging').empty().html(data).fadeIn('slow');
                toggleLoginFlowBars(true);
                navigateTo('signUp');
            },
            error: handleMemberSpaRequestError,
        });
    }

    function OpenMyPledges() {
        runAjaxCommand(routes().myPledges).then(function () {
            navigateTo('pledges');
        });
    }

    function resolveAccountSettingsTab(tabOrEvent) {
        if (typeof tabOrEvent === 'string' && Object.prototype.hasOwnProperty.call(ACCOUNT_SETTINGS_PAGE_BY_TAB, tabOrEvent)) {
            return tabOrEvent;
        }
        return 'personal';
    }

    function openAccountSettings(tabOrEvent) {
        const tab = resolveAccountSettingsTab(tabOrEvent);
        const page = accountSettingsPageForTab(tab);
        navigateWithOverlay({
            url: routes().accountSettingsView,
            type: 'GET',
            success(data) {
                navigateTo(page);
                $('#index_paging').empty().html(data).fadeIn('slow');
                syncFullPageBodyClasses();
                initSettingsNavScroll(document.getElementById('index_paging'));
            },
            error: handleMemberSpaRequestError,
        });
    }

    function pinValidation(pinValue) {
        const otpLen = pinValue.length;
        const $authOtpBtn = $('.member_confirm button#authenticateOtp');
        if (!$authOtpBtn.length) {
            return;
        }
        if (otpLen >= 5 && otpLen <= 8) {
            $authOtpBtn.removeAttr('disabled');
        } else {
            $authOtpBtn.attr('disabled', 'disabled');
        }
    }

    function buildRouter() {
        return createRouter(memberPages(), {
            home: openIndexPage,
            signIn: MemberLoginPage,
            signUp: MemberRegisterPage,
            recoverPin: MemberForgotPage,
            donate: backToDonationPage,
            donateAmount: backToAmountPage,
            donateFrequency: backToFreqDurPage,
            donateDetails: backToDonorInfoPage,
            donatePayment: openPaymentPage,
            donateSavedCards: openSavedPaymentPage,
            donateCharity: routeCharityDonation,
            pledges: OpenMyPledges,
            pledgesPay: OpenMyPledges,
            accountSettingsPersonal: function () { openAccountSettings('personal'); },
            accountSettingsPayment: function () { openAccountSettings('payment'); },
            accountSettingsMiSheberach: function () { openAccountSettings('mi-sheberach'); },
            accountSettingsAppearance: function () { openAccountSettings('appearance'); },
            accountSettingsTax: function () { openAccountSettings('tax'); },
            accountSettingsCongregations: function () { openAccountSettings('congregations'); },
            seating: OpenSeatingPage,
            seatingPlan: OpenSeatingPage
        }, openIndexPage, MEMBER_PAGE_TITLES);
    }

    const navExports = {
        showAlertMsg: showAlertMsg,
        resetIndexHeader: resetIndexHeader,
        openIndexPage: openIndexPage,
        showShabbosPage: showShabbosPage,
        OpenDonationPage: openDonationPage,
        OpenSeatingPage: OpenSeatingPage,
        backToDonationPage: backToDonationPage,
        OpenAmountPage: openAmountPage,
        backToAmountPage: backToAmountPage,
        OpenFreqDurPage: openFreqDurPage,
        OpenRecurringPresetAmount: openRecurringPresetAmount,
        backToFreqDurPage: backToFreqDurPage,
        OpenDonorInfoPage: openDonorInfoPage,
        backToDonorInfoPage: backToDonorInfoPage,
        openMemberPayBillPage: openMemberPayBillPage,
        OpenPaymentPage: openPaymentPage,
        OpenSavedPaymentPage: openSavedPaymentPage,
        routeCharityDonation: routeCharityDonation,
        MemberLoginPage: MemberLoginPage,
        MemberLogOut: memberLogOut,
        MemberForgotPage: MemberForgotPage,
        MemberRegisterPage: MemberRegisterPage,
        OpenMyPledges: OpenMyPledges,
        openAccountSettings: openAccountSettings,
        openMemberOpenPaymentAddModal: openMemberOpenPaymentAddModal,
        ProcessDonorInfoSubmit: processDonorInfoSubmit,
        resendOTP: resendOTP,
        runAjaxCommand: runAjaxCommand,
        pinValidation: pinValidation,
        toggleLoginFlowBars: toggleLoginFlowBars,
        openSchedule: openSchedule
    };

    Object.entries(navExports).forEach(function (entry) {
        registerMemberNavAction(entry[0], entry[1]);
    });
    registerMemberNavAction('openZmanim', openZmanim);
    $.extend(window, navExports);

    $(document)
        .off('click.memberNavAction', '[data-nav-action]')
        .on('click.memberNavAction', '[data-nav-action]', function (e) {
            e.preventDefault();
            const $el = $(this);
            const action = $el.data('navAction');
            if (action === 'routeCharityDonation') {
                runMemberNavAction(action, $el.data('charityId'), $el.data('amount'));
                return;
            }
            runMemberNavAction(action);
        });

    initOpenCreditAddModal();
    initScheduleModal();
    initMemberPaymentDependencies();
    initMemberNavDeps();
    wireBackToHistory();

    return buildRouter();
}
